import { ChangeDetectorRef, Component, ElementRef, EventEmitter, OnInit, Output, Renderer2, ViewChild, ViewChildren } from '@angular/core';
import { Router } from '@angular/router';
import { AppState } from '../app.service';
import { ClientService } from '../client/client.service'
import { HomeV5Service } from '../pages/home-v5/home-v5.service';
import { Path } from '../path/path-v2.model';
import { ToasterService } from '../toaster.service';
import { CohortService } from '../cohorts/cohort.service'
import { Location } from '@angular/common';
import { slideInLeftOnEnterAnimation, slideOutLeftOnLeaveAnimation, slideOutRightAnimation, slideOutRightOnLeaveAnimation } from 'angular-animations';
import { ModalController,Platform } from '@ionic/angular';
import { I18n } from '../i18n.service';
import { CordovaService } from '../cordova.service';
import { SessionService } from '../session/session.service';
import { HomeUiService } from '../new-design/home-ui.service';
export interface Collapse {
  isCollapsable: boolean;
  isCollapsed: boolean;
}

@Component({
  selector: 'app-all-paths-v2',
  templateUrl: './all-paths-v2.component.html',
  styleUrls: ['./all-paths-v2.component.scss'],
  animations:[slideOutRightAnimation({duration:500}),
  slideOutRightOnLeaveAnimation({duration:100}),
  slideOutLeftOnLeaveAnimation({duration:150}),
  slideInLeftOnEnterAnimation({duration:500}),
  slideOutRightAnimation({duration:500})
]
})
export class AllPathsV2Component implements OnInit {

  isMobile;
  animationState;
  client: any
  @Output() animationStateChange = new EventEmitter()
  collapse: Array<Collapse>=[];
  isExpanded: boolean[] = []
  alldata: any
  allpath: any
  clientId: any
  currentpathId: any
  user: any;
  isonboardingcompleted: any;
  isActivePath: any;
  currentPath: Path
  allContentCompleted: boolean
  cohorts: any
  selectedPathsList: any[] = []
  pathRegistration;
  enabledAttributes: any
  pathVersion: boolean
  userEmail: string
  onCordova: boolean = false // LUMBA-982
  pathGroups: any
  /** The client's Series, as the allpaths response listed them. */
  clientSeries: any[] = [];
  rowHovered: boolean[] = [];
  filteredPathsGroups: any[] = [];
  expandedPaths: { [key: string]: boolean } = {};
  reviewPaths= [];
  /**
   * One section per Series the learner can reach, in the order the client sorted them — a coloured
   * header bar and its Cycles under it, the way Cycles in progress reads. Empty until the server
   * sends Series, which is what keeps this screen looking exactly as it did for a client with none.
   */
  seriesSections: Array<{ id: any; name: string; color?: string; paths: any[] }> = [];

  /** Reachable Cycles that sit in no Series — the Other section, listed after the named ones. */
  ungroupedCycles: any[] = [];

  /** Which section the filter is showing: 'all', 'progress', or one Series id. */
  seriesFilter: any = 'all';

  /** The filter's options, rebuilt when the Cycle lists are. */
  seriesFilterOptions: Array<{ id: any; name: string }> = [];

  /**
   * The header on the phone's filter dialog. A field, not an object literal in the template: a new
   * object on every pass is a new input value for ion-select, every pass.
   */
  filterInterfaceOptions: any = {};
  resumePaths = []
  @ViewChild('textCount') textCount: ElementRef;
  @ViewChildren('cardElement') cardElement: ElementRef[];
  maxHeight: number = 80;
  dailyStepsArray;
  currentActiveChapterIndex: number;
  isLoading = true;
  isChangingPath = false;
  constructor(
    private clientService: ClientService,
    private homeService: HomeV5Service,
    private appState: AppState,
    private toasterService: ToasterService,
    private cdRef: ChangeDetectorRef,
    private router: Router,
    private render: Renderer2,
    private modalController: ModalController,
    public cohortService: CohortService,
    public location: Location,
    public i18n: I18n,
    public homeUIService: HomeUiService,
    public platform: Platform,
    public cordovaService: CordovaService,
    private homeUiService: HomeUiService,
    public sessionService: SessionService
  ) {
    this.onCordova = this.cordovaService.onCordova
    this.user = this.appState.get('currentUser')
    this.userEmail = this.user.email
    this.currentPath = this.appState.get('currentPath')
    const clientId = localStorage.getItem('clientId')
    this.allpath =this.appState.get("allPathsData")
    if (clientId) {
      this.clientId = clientId
    }
    
    this.setPathVersion()

    this.pathRegistration = this.appState.get('pathRegistration')
    this.currentActiveChapterIndex = this.appState.get('currentActiveChapter')
    this.dailyStepsArray = this.appState.get("DailyStepsData");  
    this.currentpathId = this.currentPath?.id
    this.cohorts = this.appState.get("cohortsData")
    // if(this.currentPath.areAllChaptersStepsReviewed(this.dailyStepsArray)){
    //      this.allpaths('no-cache')
    // }
    // else {
    //    this.allpaths();
    // }
    // Re-fetch cohorts when they're missing OR when this IS a cohort client but the cached list is
    // empty. An empty [] is truthy, so a stale/empty cache would otherwise be treated as "already
    // loaded" and cohort cycles would never appear (the real fix for the reported bug is client
    // config: isCohort must be true; this just keeps a stale-empty cache from silently blocking it).
    // Non-cohort clients keep their legitimately-empty [] cache and skip the extra call.
    const currentClient = this.appState.get('currentClient');
    // isCohort NULL means "never set" and is treated as on; only an explicit false is off.
    if (!this.cohorts || (currentClient?.isCohort !== false && this.cohorts?.length === 0)) {
      this.cohortService.getCohort(Number(clientId)).subscribe(cohort => {
        this.appState.set("cohortsData",cohort.data)
        this.cohorts = cohort.data;
        this.loadPaths();
      });
    } else {
      this.loadPaths();
    }
  }

  setPathVersion(){
    this.enabledAttributes = this.appState.get("routineVersion")
    if (this.enabledAttributes?.pathVersion) {
      this.pathVersion = this.enabledAttributes?.pathVersion
    } else {
      this.pathVersion = false
    }
  }
  truncateText(text: string, maxLength: number) {
    if (text.length <= maxLength) return text;

    const truncated = text.slice(0, maxLength);
    const lastSpace = truncated.lastIndexOf(' ');

    return truncated.slice(0, lastSpace);
  }
  closePage(){
    this.appState.set('isAllPaths', false);
    this.homeUIService.getLastModal();
    this.modalController.dismiss();
  
  }
  ngOnInit() { 
    this.isMobile = this.appState.get('isMobile')
  }
  ngAfterViewInit() {

  }

  getCollapsedText() {
    if (this.selectedPathsList?.length > 0 && this.selectedPathsList?.length == this.collapse?.length) {
      return true;
    }
    if (this.appState.get("isAllPaths") && this.selectedPathsList?.length > this.collapse?.length) {
      // Pre-fill the entire collapse array at once so this condition becomes false immediately
      // on the next change detection cycle — prevents one-push-per-cycle infinite loop.
      this.collapse = Array.from(
        { length: this.selectedPathsList.length },
        () => ({ isCollapsable: false, isCollapsed: false })
      );
      setTimeout(() => {
        this.cardElement?.forEach((cardElement, index) => {
          const cardHeight = cardElement.nativeElement.offsetHeight;
          if (cardHeight > this.maxHeight) {
            this.collapse[index] = { isCollapsable: true, isCollapsed: true };
            this.render.addClass(this.textCount.nativeElement, 'reply-texts');
          } else {
            this.collapse[index] = { isCollapsable: false, isCollapsed: false };
          }
        });
      }, 100);
    }
    return true;
  }

  // async allpaths(type?) {
  //   await this.clientService.getAllpaths(Number(this.clientId), type)
  //     .subscribe(async (client) => {
  //       if (!client || !client?._data) {
  //         this.isLoading = false;
  //         return;
  //       }

  //       this.client = client;
  //       this.alldata = client._data;
  //       const kyperPaths = Array.isArray(this.alldata.paths)
  //         ? this.alldata.paths.filter(
  //           path => path?.isKyperGenerated === true && path?.name?.trim()?.length > 0
  //         )
  //         : [];

  //       this.allpath = kyperPaths;
  //       this.appState.set('allPathCount', kyperPaths.length);
  //       this.appState.set('allPathsData', kyperPaths);

  //       if (this.allpath?.length > 0) {
  //         this.reviewPaths = this.allpath.filter(path => path.isKyperPathCompleted === 2);
  //       }
  //       console.log("this.cohorts?.length", this.cohorts?.length);
  //       if (this.cohorts?.length == 0) {
  //         setTimeout(() => {
  //           this.getCohortPaths(this.user.cohortId, this.cohorts, this.allpath)
  //           this.getPathsFromCohortForWeb(this.user.cohortId, this.allpath)
  //         }, 700)
  //       }
  //       else {
  //         this.getCohortPaths(this.user.cohortId, this.cohorts, this.allpath)
  //         this.getPathsFromCohortForWeb(this.user.cohortId, this.allpath);
  //       }
  //      this.isLoading = false;
  //     },(error)=>{
  //       this.isLoading = false;
  //       this.toasterService.error(this.i18n.t('Server or connection issue. Please check your internet connection.'))
  //     })
  // }
private loadPaths() {
    const cachedPaths = this.appState.get('allPathsData');
    const chapters = this.dailyStepsArray;
    const firstChapter = chapters?.[0];
    const lastChapter  = chapters?.[chapters.length - 1];
    const firstStep = firstChapter?.steps?.[0];
    const lastStep  = lastChapter?.steps?.[lastChapter.steps?.length - 1];

    const firstStepStarted   = !!firstStep?.stepStatus;
    const lastStepCompleted  = lastStep?.stepStatus === 'Review';

    const needsFirstStepRefresh = firstStepStarted  && !this.appState.get('allPathsFirstStepRefreshed');
    const needsLastStepRefresh  = lastStepCompleted && !this.appState.get('allPathsLastStepRefreshed');

    if (needsFirstStepRefresh) { this.appState.set('allPathsFirstStepRefreshed', true); }
    if (needsLastStepRefresh)  { this.appState.set('allPathsLastStepRefreshed',  true); }

    if (needsFirstStepRefresh || needsLastStepRefresh || !cachedPaths) {
      this.allpaths();
    } else {
      this.processPaths(cachedPaths);
    }
  }

  async allpaths() {
    await this.clientService.getAllpaths(Number(this.clientId))
      .subscribe(
        (client:any) => {
          if (!client || !client?._data?.paths) {
            this.isLoading = false;
            return;
          }
          this.client  = client;
          this.alldata = client._data;
          this.allpath = this.alldata.paths
          // The client's whole Series catalogue, read from the raw response: the typed Client model
          // copies only the fields it lists, and `series` is not one of them.
          this.clientSeries = this.alldata.series || [];
          this.appState.set('clientSeries', this.clientSeries);
          this.processPaths(this.allpath);
        },
        (error) => {
          this.isLoading = false;
          this.toasterService.error(this.i18n.t('Server or connection issue. Please check your internet connection.'));
        }
      );
  }

  private processPaths(paths: any[]) {
    // The catalogue that came with the response, where this screen fetched one. On the cached-paths
    // route it did not: allpaths() never ran, so without this the sections would be built from the
    // thin membership on each Cycle alone — which carries a name and a colour but no sortOrder, and
    // the client's own ordering would be lost.
    if (!this.clientSeries?.length) {
      this.clientSeries = this.appState.get('clientSeries') || [];
    }
    this.allpath = paths;
    this.appState.set('allPathCount', paths?.length);
    this.appState.set('allPathsData', paths);
    if (paths?.length > 0) {
      this.reviewPaths = paths.filter(path => path.isKyperPathCompleted === 2);
    }
    if (this.cohorts?.length === 0) {
      setTimeout(() => {
        this.getCohortPaths(this.user.cohortId, this.cohorts, paths);
        this.getPathsFromCohortForWeb(this.user.cohortId, paths);
        this.buildSeriesTabs(paths);
      }, 700);
    } else {
      this.getCohortPaths(this.user.cohortId, this.cohorts, paths);
      this.getPathsFromCohortForWeb(this.user.cohortId, paths);
      this.buildSeriesTabs(paths);
    }
    this.isLoading = false;
  }


  textExpand(path,collpase) {
    if(collpase){
      path.isCollapsed = false;
      path.isCollapsable = true;
    }
    else {
      path.isCollapsed = true;
      path.isCollapsable = true;
    }
    this.cdRef.detectChanges();
  }

  public changePath(active_path_id) {
    // The Cycle they are already in. Switching to it would clear the step state, refetch everything
    // and reload the home screen to arrive exactly where they started — so say so instead.
    if (active_path_id != null && this.currentpathId != null
        && String(active_path_id) === String(this.currentpathId)) {
      this.toasterService.warning(this.i18n.t('You are already on this cycle'));
      return;
    }
   this.isChangingPath = true;
    const request = {
      'user_id': this.user.id,
      'active_path_id': active_path_id
    }
    this.homeService.subpathchange(request, 'All Cycles-New-V2').subscribe(
      (response) => {
        this.appState.set('isAllPaths', false)
        this.appState.set("screensViewed", undefined);
        this.appState.set('stepsArray', undefined)
        this.appState.set('stepObject', undefined)
        this.appState.set('levelUpdateData', undefined)
        this.appState.set('allLevelsCompleted', undefined)
        this.appState.set('levelUpdated', undefined)
        this.appState.set('showUpdatedScreens', undefined)
        this.appState.set('levelSaveData', undefined)
        this.appState.set('weekDays', undefined)
        this.appState.set("activeCloseoutWelcomeScreen", undefined);
        // Clear stale path-specific data so the new path loads fresh
        this.appState.set('DailyStepsData', undefined);
        this.appState.set('currentPath', undefined);
        this.appState.set('currentChapterInfo', undefined);
        this.appState.set('dailyStreaksInfo', undefined);
        this.appState.set('currentActiveChapter', undefined);
        this.appState.set('currentActiveStepIndex', undefined);
        this.appState.set('reviewingStepIndex', undefined);
        this.appState.set('currentScheduleDay', undefined);
        this.appState.set('scheduleDayForCurrentStep', undefined);
        this.appState.set('daysOfContent', undefined);
        this.appState.set('totalDayOfContent', undefined);
        this.appState.set('allContentCompleted', undefined);
        this.appState.set('language', undefined);
        this.appState.set('routineVersion', undefined);
        this.appState.set('allPathsData', undefined);
        this.appState.set('allPathsFirstStepRefreshed', undefined);
        this.appState.set('allPathsLastStepRefreshed', undefined);
        localStorage.removeItem('currentDayAfterScreenView')
        localStorage.removeItem('stepCompleted')
        // Reset so new subscribers don't get replayed old-path step data before refreshSession completes
        this.homeUiService.resetStepApiData();
        let data = response["data"];
        try {
          // let isOnboardContentPresent = data.onboardingSurvey || data?.isIntroVideo;
          // if (data?.isonboardingcompleted.constructor === Array && data?.isonboardingcompleted?.length > 0 && isOnboardContentPresent) {
          //   let value = data['isonboardingcompleted'][0];
          //   this.isonboardingcompleted = value["isonboardingcompleted"];
          //   if ((this.isonboardingcompleted === false || this.isonboardingcompleted === null) && isOnboardContentPresent) {
          //     this.router.navigate(["/onboarding"], { state: { onboardingSurvey: data.onboardingSurvey, isIntroVideo: data?.isIntroVideo } });                          
          //   } else if (this.isonboardingcompleted === true) {
          //     this.router.navigate(['/main']);
          //   }
          // } else if(data?.isonboardingcompleted.constructor === Array && data?.isonboardingcompleted.length===0 && isOnboardContentPresent){
          //     this.router.navigate(["/onboarding"], { state: { onboardingSurvey: data.onboardingSurvey, isIntroVideo: data?.isIntroVideo } });                          
          // } else {
            this.homeUiService.checkSubpathStatus();
            this.router.navigate(['/main']);
          // }
      }catch (error) {
          this.router.navigate(['/main']);
        }
        this.refresh()
      }, (error) => {
        this.isChangingPath = false;
        console.log('error for path change:', error);
        // this.spinnerService.off();
        this.toasterService.error(this.i18n.t('Server or connection issue. Please check your internet connection.'))
      }
    )
  }

  refresh() {
    return new Promise(resolve => {
      // here to fetch the data and rerender the contents.
      this.appState.refreshMainComponent.emit()
      setTimeout(resolve, 0)
    })
  }

  showChangePath(pathId){
    if(pathId!=this.currentpathId){
      // this.getCollapsedText()
      return true
    } 

    else false
  }

  receiveState(event: any){
    setTimeout(() => {
      this.animationState = event
    }, 10);
  }
  

  getCohortPaths(cohortId: number, cohorts: any, allpaths: any) {
    this.selectedPathsList = [];
    // Toggle-aware accessible cycles: cohort + adhoc when the cohort toggle is ON,
    // adhoc only when OFF; the active cycle is always included. No "show all paths"
    // fallback — when the user has no accessible cycles the list stays limited to the
    // active cycle (if any).
    const client = this.appState.get('currentClient');
    // The cycles themselves, because a Series grant names a Series and only their membership says
    // which cycles that is.
    const access = this.homeUIService.computeCycleAccess(this.user, client, cohorts, allpaths);
    const availableIds = access.availableIds;
    this.selectedPathsList = (allpaths || []).filter((p: any) => availableIds.includes(Number(p?.id)));

    // Always ensure the active path is present regardless of cohort membership or status
    const activePath = allpaths?.find((p: any) => p.id === this.currentpathId);
    if (activePath && !this.selectedPathsList.find((p: any) => p.id === activePath.id)) {
      this.selectedPathsList.unshift(activePath);
    }
    let activepath =[]
    activepath= this.selectedPathsList?.filter(path => path?.id == this.currentpathId)
    if(activepath && activepath?.length>0 && this.selectedPathsList?.length>0) {
      this.selectedPathsList =[activepath[0], ... this.selectedPathsList.filter(path => path != activepath[0])];
    }

  }
  getPathsFromCohortForWeb(cohortId, allpath) {
    this.filteredPathsGroups = [];
    if (allpath?.length > 0) {
      this.reviewPaths = this.allpath.filter(path => path.isKyperPathCompleted === 2);
      this.resumePaths = allpath.filter(path => path.isKyperPathCompleted === 1 && this.showChangePath(path.id));
    }
    // Toggle-aware accessible cycles (cohort + adhoc when the cohort toggle is ON, adhoc
    // only when OFF), excluding the active cycle which is shown separately. No "show all
    // paths" fallback — an empty accessible set yields an empty list.
    const client = this.appState.get('currentClient');
    const access = this.homeUIService.computeCycleAccess(this.user, client, this.cohorts, allpath);
    // access.assignedIds are Number()-cast. API path ids can arrive as strings, and Array.includes
    // uses strict === — so `[6,7].includes("6")` is false and every accessible cycle silently drops,
    // leaving only the active one (which getCohortPaths matches via its own Number() cast). Cast both
    // sides here too so the adhoc/cohort "remaining" cycles actually match.
    const activePathId = Number(this.user.activePathId);
    const cyclePathIds = access?.assignedIds?.filter(id => id != activePathId);
    this.resumePaths = this.resumePaths?.filter(path => cyclePathIds?.includes(Number(path?.id)));
    const matchingPaths = this.allpath?.filter((path: any) => cyclePathIds?.includes(Number(path?.id)));
    if (matchingPaths?.length > 0) {
      const pathsWithCategory = matchingPaths?.map((path: any) => ({
        ...path,
        language: allpath.find((p: any) => p.id === path.id)?.language || path.language,
        category: allpath.find((p: any) => p.id === path.id)?.isKyperPathCompleted == 1 ? 'Resumed' : allpath.find((p: any) => p.id === path.id)?.isKyperPathCompleted == 2 ? 'Review' : 'Normal'
      }));
      this.filteredPathsGroups.push({
        paths: pathsWithCategory?.filter((path: any) => path?.category != 'Resumed')
      });
      if (this.filteredPathsGroups?.length > 0) {
        let filteredPaths = this.filteredPathsGroups.filter(
          item => Array.isArray(item.paths) && item.paths.length > 0);
        this.filteredPathsGroups = filteredPaths
      }
    }
  }

  /**
   * Every cycle the learner can reach, the active one included — what the Series tabs draw from.
   *
   * The same access rule the rest of this screen uses, so a Series tab can never offer a cycle the
   * All Cycles tab does not.
   */
  private accessibleCycles(paths: any[]): any[] {
    const access = this.homeUIService.computeCycleAccess(
      this.user, this.appState.get('currentClient'), this.cohorts, paths,
    );
    const ids = (access?.availableIds || []).map((id: any) => Number(id));
    return (paths || [])
      .filter((path: any) => ids.includes(Number(path?.id)))
      .map((path: any) => this.withCategory(path));
  }

  /**
   * The status the card reads to label its button: Launch, Resume or Review.
   *
   * Set here as well as in getPathsFromCohortForWeb because the card falls through to Review when
   * it is missing — so a Cycle handed over without one was offered as "Review" whatever its real
   * progress was. Copied rather than written onto the path, which is shared with every other list
   * on this screen.
   */
  private withCategory(path: any): any {
    const progress = path?.isKyperPathCompleted;
    return {
      ...path,
      category: progress == 1 ? 'Resumed' : progress == 2 ? 'Review' : 'Normal',
    };
  }

  /**
   * A tab per Series, from the catalogue on the client and the membership on each cycle.
   *
   * A cycle in three Series is listed under all three — membership is a list, not a home. A Series
   * the learner can reach nothing in raises no tab at all, which is what keeps a Series whose only
   * cycle is disabled (or ungranted) from showing as an empty one.
   */
  private buildSeriesTabs(paths: any[]): void {
    const visible = this.accessibleCycles(paths);

    // The catalogue decides the order, but it does not get the last word on what exists: a Cycle
    // can name a Series the catalogue in the same response does not list, and the membership
    // carries id, name and colour — everything a tab needs. Dropping it would lose the Cycle a tab
    // because the two halves of one response disagreed.
    const known = new Map<string, any>();
    // A disabled Series is a soft delete: it grants nothing and shows nowhere. Skipped in the
    // catalogue AND in the memberships, so a Cycle whose only Series was switched off falls to
    // Other — and where that leaves no Series at all, the screen is the list it always was.
    const disabled = new Set<string>();
    (this.clientSeries || []).forEach((series: any) => {
      if (series?.id == null) { return; }
      if (series?.enabled === false) { disabled.add(String(series.id)); return; }
      known.set(String(series.id), series);
    });
    visible.forEach((path: any) => (path?.series || []).forEach((member: any) => {
      if (member?.id == null || disabled.has(String(member.id))) { return; }
      if (member?.enabled === false) { disabled.add(String(member.id)); known.delete(String(member.id)); return; }
      if (!known.has(String(member.id))) {
        // Sorted after everything the catalogue named, in the order the Cycles mention them.
        known.set(String(member.id), { ...member, sortOrder: Number.MAX_SAFE_INTEGER });
      }
    }));

    const catalogue = [...known.values()].sort(
      (a: any, b: any) => (a?.sortOrder ?? 0) - (b?.sortOrder ?? 0),
    );

    const tabs = catalogue
      .map((series: any) => ({
        id: series?.id,
        name: series?.name,
        color: series?.color,
        paths: visible.filter((path: any) =>
          (path?.series || []).some((member: any) => Number(member?.id) === Number(series?.id))),
      }))
      .filter((tab) => tab.paths.length > 0);

    this.seriesSections = tabs;
    // Their own section, named Other, below the Series. Only where there are Series to be other
    // than: with none, this is every Cycle and the screen keeps the heading it always had.
    // "In no Series" means in no Series that is still on: a Cycle whose only membership was
    // disabled belongs here, not nowhere.
    this.ungroupedCycles = visible.filter((path: any) =>
      !(path?.series || []).some((member: any) => known.has(String(member?.id))));
    this.rebuildFilterOptions();
    this.filterInterfaceOptions = { header: this.i18n.t('Filter Cycles') };
    // A filter pointing at a Series that is no longer on screen would show nothing at all.
    if (!this.seriesFilterOptions.some((option) => option.id === this.seriesFilter)) {
      this.seriesFilter = 'all';
    }
  }

  /**
   * What the filter offers: everything, the in-progress Cycles, each Series, then Other.
   *
   * Built once per load rather than read from a getter. A getter would hand the template a NEW
   * array on every change-detection pass, so the chip row would be torn down and rebuilt on each
   * one — which is what locked this screen up.
   */
  rebuildFilterOptions(): void {
    // Nothing to filter by when none of the Cycles the learner can reach is in a Series: the screen
    // is the list it has always been, with no filter row over it.
    if (!this.seriesSections?.length) {
      this.seriesFilterOptions = [];
      return;
    }

    const options: Array<{ id: any; name: string }> = [{ id: 'all', name: this.i18n.t('All') }];
    if (this.resumePaths?.length > 0) {
      options.push({ id: 'progress', name: this.i18n.t('Cycles in progress') });
    }
    (this.seriesSections || []).forEach((series) => options.push({ id: series.id, name: series.name }));
    if (this.seriesSections?.length > 0 && this.ungroupedCycles?.length > 0) {
      options.push({ id: 'other', name: this.i18n.t('Other') });
    }
    this.seriesFilterOptions = options;
  }

  /** Stable identity for the chip row, so a rebuild does not re-create every button. */
  trackFilterOption(_index: number, option: { id: any }) {
    return option?.id;
  }

  /** Whether a section is on screen under the current filter. */
  showsSection(id: any): boolean {
    return this.seriesFilter === 'all' || this.seriesFilter === id;
  }

  selectSeriesFilter(id: any): void {
    this.seriesFilter = id;
  }

  tForPath(key: string, path: any): string {
    return path?.language
      ? this.i18n.tForLang(key, path.language)
      : this.i18n.t(key);
  }

  expandCollapse(index) {
    this.isExpanded[index] = !this.isExpanded[index]
  }
  toggleDescription(path: any): void {
    this.expandedPaths[path.id] = !this.expandedPaths[path.id];
  }

  getTextContent(html: string): string {
    const tempElement = document.createElement('div');
    tempElement.innerHTML = html;
    return tempElement.innerText || tempElement.textContent || '';
  }
  
}
